"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCloneable = void 0;
function isCloneable(something) {
    return (typeof (something["clone"]) === "function" &&
        something["clone"].length === 0);
}
exports.isCloneable = isCloneable;
